import { fetchCurrentEvents } from "@/api/apiFunction";
import WFacbook from "@/assets/icons/WFacbook";
import Winsta from "@/assets/icons/Winsta";
import WYt from "@/assets/icons/WYt";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import slugify from "slugify";
export default function Header() {
  const { data, isSuccess } = useQuery({
    queryKey: ["currentEvent"],
    queryFn: fetchCurrentEvents,
  });
  const slugifyTitle = (title: string) => {
    return slugify(title, { lower: true, strict: true });
  };

  return (
    <div className="w-full bg-[#009FA6]  text-white shadow-lg overflow-hidden">
      <div className="p-2 md:px-6 w-full flex justify-between items-center">
        <p className="whitespace-nowrap text-sm mx-2 md:ml-6">Register For:</p>
        <div className="w-full flex md:w-3/4 overflow-hidden items-center">
          <div className="flex whitespace-nowrap animate-scroll">
	  <Link
	    key={19}
	    to={'https://www.townscript.com/e/apla-pune-marathon-season-5-2025-000313'}
            className="inline-block text-sm px-5 py-1 mx-2 text-black bg-white rounded-full "
	  >
	  	Click Here to Register for Apla Pune Marathon Season 5, 12th October 2025
	  </Link>
            {isSuccess && data?.data ? (
              <>
                {data.data.map((event: any) => (
                  <Link
                    key={event.id}
                    to={`/event/${slugifyTitle(event.title + "-" + event.id)}`}
                    className="inline-block text-sm px-5 py-1 mx-2 text-black bg-white rounded-full "
                  >
                    {event.title}
                  </Link>
                ))}
              </>
            ) : (
              <span className="inline-block px-4 py-1 mx-2 bg-white text-teal-600 rounded-full">
                Upcoming Events
              </span>
            )}
          </div>
        </div>
        <div className="hidden md:flex space-x-4 mt-2 md:mt-0">
          <div className="flex flex-row gap-4">
            <a
              href="https://www.facebook.com/champendurance"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:scale-110 transition-transform duration-300"
            >
              <WFacbook />
            </a>
            <a
              href="https://www.instagram.com/champendurance"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:scale-110 transition-transform duration-300"
            >
              <Winsta />
            </a>
            <a
              href="https://www.youtube.com/channel/UClKjHJ7P8vy12gVWRU5ilug"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:scale-110 transition-transform duration-300"
            >
              <WYt />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
